import { HTMLAttributes, forwardRef } from 'react';
import { cn } from '../../lib/utils';

/**
 * Surface — Skuulbe 3-Tier Elevation System
 *
 * elevation=0  →  Flat base container (no shadow, transparent bg)
 * elevation=1  →  Standard card  (bg-white, border, premium-shadow)
 * elevation=2  →  Floating overlay (backdrop-blur glassmorphism)
 */
export type SurfaceElevation = 0 | 1 | 2;

const elevationClasses: Record<SurfaceElevation, string> = {
  0: 'bg-transparent',
  1: 'bg-white border border-slate-100 premium-shadow rounded-2xl',
  2: 'bg-white/80 backdrop-blur-xl border border-white/50 shadow-2xl shadow-black/10 rounded-3xl',
};

interface SurfaceProps extends HTMLAttributes<HTMLDivElement> {
  elevation?: SurfaceElevation;
  /** Useful for page-level sections or padded content areas */
  padded?: boolean;
}

export const Surface = forwardRef<HTMLDivElement, SurfaceProps>(
  ({ elevation = 1, padded = false, className, children, ...rest }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(elevationClasses[elevation], padded && 'p-6', className)}
        {...rest}
      >
        {children}
      </div>
    );
  }
);

Surface.displayName = 'Surface';
